import React, { Component } from "react";

class Media extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        {this.renderImage()}
        {this.renderUrl()}
      </React.Fragment>
    );
  }

  renderUrl() {
    if (this.props.answer.url) {
      return (
        <div className="div_url">
          <label className="url_title">{this.props.answer.url_title}</label>
          <label className="url_description">
            {this.props.answer.url_description}
          </label>
        </div>
      );
    }
  }
  renderImage() {
    if (this.props.answer.answer_type === "text") {
      if (this.props.openMedia === true) {
        return (
          <label className="media_v2_label media_text max_width_500 pt-3 pb-3 pl-3 pr-3">
            {this.props.answer.name}
          </label>
        );
      }
      return (
        <label
          className="media_v2_label media_text max_width_500  pl-1 pr-1"
          style={{ WebkitBoxOrient: "vertical" }}
        >
          {this.props.answer.name}
        </label>
      );
    }

    var src = "";
    if (this.props.answer.answer_type === "image") {
      src = this.props.answer.image_url_original;
    } else if (this.props.answer.answer_type === "video") {
      src = this.props.answer.video_url_image;
    }

    return (
      <label className="media_v2_label media_image">
        <img className="image_media content-cover" src={src} alt="upload" />
      </label>
    );
  }
}

export default Media;



// WEBPACK FOOTER //
// ./src/components/list/interface/media/media.jsx